import { useState } from "react";
import styles from "./EditProductModal.module.css";

export default function EditProductModal({ product, onSave, onClose }) {
  const [form, setForm] = useState({
    type: product.type || "Drug",
    description: product.description || "",
    manufacturer: product.manufacturer || "",
    lotNumber: product.lotNumber || "",
    expiryDate: product.expiryDate || "",
    minOrderLine: product.minOrderLine ?? "",
  });
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!form.description.trim() || !form.manufacturer.trim() || !form.lotNumber.trim()) {
      setError("Description, manufacturer, and lot number are required"); return;
    }
    if (!form.expiryDate) {
      setError("Expiry date is required"); return;
    }
    if (form.minOrderLine !== "" && (isNaN(Number(form.minOrderLine)) || Number(form.minOrderLine) < 0)) {
      setError("Min order line must be a non-negative number"); return;
    }
    const updates = {
      type: form.type,
      description: form.description.trim(),
      manufacturer: form.manufacturer.trim(),
      lotNumber: form.lotNumber.trim(),
      expiryDate: form.expiryDate,
    };
    if (form.minOrderLine !== "") {
      updates.minOrderLine = Number(form.minOrderLine);
    } else {
      updates.minOrderLine = "";
    }
    onSave(updates);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>Edit Product</div>
          <button onClick={onClose} className={styles.closeBtn}>x</button>
        </div>

        <div className={styles.readonlyInfo}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Barcode:</span>
            <span className={styles.infoValue}>{product.barcode}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Stock:</span>
            <span className={styles.infoValue}>{product.stock ?? 0}</span>
          </div>
        </div>

        <div className={styles.fieldGroup}>
          <div className={styles.label}>Type</div>
          <div className={styles.typeButtons}>
            {["Drug", "Supply"].map(t => (
              <button key={t} onClick={() => setForm(f => ({ ...f, type: t }))}
                className={form.type === t ? styles.typeBtnActive : styles.typeBtn}>
                {t}
              </button>
            ))}
          </div>
        </div>

        {["description", "manufacturer", "lotNumber"].map(field => (
          <div key={field} className={styles.fieldGroup}>
            <div className={styles.label}>
              {field === "lotNumber" ? "Lot Number" : field}
            </div>
            <input value={form[field]}
              onChange={e => setForm(f => ({ ...f, [field]: e.target.value }))}
              placeholder={
                field === "description" ? "e.g. Vancomycin 1GM" :
                field === "manufacturer" ? "e.g. HOSPIRA" :
                "e.g. LOT-2024-001"
              }
              className={styles.input} />
          </div>
        ))}

        <div className={styles.fieldGroup}>
          <div className={styles.label}>Expiry Date</div>
          <input type="date" value={form.expiryDate}
            onChange={e => setForm(f => ({ ...f, expiryDate: e.target.value }))}
            className={styles.input} />
        </div>

        <div className={styles.fieldGroup}>
          <div className={styles.label}>Min Order Line <span className={styles.hint}>(Optional)</span></div>
          <input type="number" min="0" value={form.minOrderLine}
            onChange={e => setForm(f => ({ ...f, minOrderLine: e.target.value }))}
            placeholder="Reorder threshold, e.g. 50"
            className={styles.input} />
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <button onClick={handleSave} className={styles.submitBtn}>
          SAVE CHANGES
        </button>
      </div>
    </div>
  );
}
